/**
 * API методы для работы с ролями
 * Дата: 28.12.2025 - Создан для TODO-013 (используется в Users Page для выбора роли)
 * Связан с: internal/handler/role.go, frontend/src/pages/Users.tsx
 */
import { apiClient } from './client';

export interface Role {
  id: string;
  name: string;
  description?: string;
  is_system: boolean;
  tenant_id?: string;
  created_at?: string;
  permissions?: Array<{ id: number; code: string; name: string }>;
}

export const rolesApi = {
  // 29.01.2026 - FIX: Добавлен tenant_id параметр для SuperAdmin
  list: async (tenantId?: string): Promise<Role[]> => {
    const params: Record<string, string> = {};
    if (tenantId) {
      params.tenant_id = tenantId;
    }
    const response = await apiClient.get('/roles', { params });
    return response.data;
  },
};

